var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85953 2.57323L1.21286 11.9999C1.09644 12.2015 1.03484 12.4301 1.03418 12.6629C1.03353 12.8957 1.09385 13.1246 1.20914 13.3269C1.32443 13.5292 1.49068 13.6977 1.69133 13.8158C1.89199 13.9339 2.12006 13.9973 2.35286 13.9999H13.6462C13.879 13.9973 14.1071 13.9339 14.3077 13.8158C14.5084 13.6977 14.6746 13.5292 14.7899 13.3269C14.9052 13.1246 14.9655 12.8957 14.9649 12.6629C14.9642 12.4301 14.9026 12.2015 14.7862 11.9999L9.13953 2.57323C9.02068 2.3773 8.85334 2.21531 8.65366 2.10288C8.45397 1.99046 8.22868 1.9314 7.99953 1.9314C7.77037 1.9314 7.54508 1.99046 7.3454 2.10288C7.14571 2.21531 6.97837 2.3773 6.85953 2.57323V2.57323Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.66667",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3333H8.0075",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3ecf596c6378b45ce5067012bd7efacf.svg";
export { ForwardRef as ReactComponent };